// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".divBox[data-v-7bcfdc32] {\n  padding: 20px;\n}\n.divBox .table-card[data-v-7bcfdc32] {\n  margin-top: 14px;\n}\n.divBox .padding-add[data-v-7bcfdc32] {\n  padding: 20px;\n}\n.divBox .table-header[data-v-7bcfdc32] {\n  margin-bottom: 20px;\n}", ""]);
// Exports
module.exports = exports;
